import classNames from "classnames";
import { MouseEvent, PropsWithChildren, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Tooltip.module.css";

type TooltipProps = PropsWithChildren<{
  message: string;
  to?: string;
  isError?: boolean;
}>;

const Tooltip = ({ message, children, to, isError }: TooltipProps) => {
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null);
  const className = classNames(
    styles.container,
    isError ? styles.error : undefined,
    children ? styles.inline : undefined,
    to ? styles.linked : undefined,
  );
  const content = (
    <>
      {!children && <>&nbsp;</>}
      {!!position && (
        <div className={styles.tooltip} style={{ top: position.y + 10, left: position.x + 5 }}>
          {message}
        </div>
      )}
    </>
  );

  const mouseEvents = {
    onMouseEnter: (event: MouseEvent) =>
      setPosition({
        x: event.clientX,
        y: event.clientY,
      }),
    onMouseMove: (event: MouseEvent) => setPosition({ x: event.clientX, y: event.clientY }),
    onMouseLeave: () => setPosition(null),
  };

  if (to) {
    return (
      <>
        {children}
        <Link className={className} to={to} onClick={(event) => event.stopPropagation()} {...mouseEvents}>
          {content}
        </Link>
      </>
    );
  }

  return (
    <>
      {children}
      <div className={className} {...mouseEvents}>
        {content}
      </div>
    </>
  );
};

export default Tooltip;
